/* JA motion — reveal-on-scroll, once. No library. Reduced-motion = no-op (CSS shows content). */
(function () {
  var d = document.documentElement;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  d.classList.add('ja-js');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  function scan(root) {
    (root || document).querySelectorAll('.ja-reveal:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  /* Bag count: one soft bump when the cart changes */
  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (b) {
      b.classList.remove('ja-bump'); void b.offsetWidth; b.classList.add('ja-bump');
    });
  });
})();
/* Rails: position indicator + prev/next (Astra r1 item 5). textContent only. */
(function () {
  function init(box) {
    var r = box.querySelector('.ja-rail'), pos = box.querySelector('[data-pos]');
    if (!r || box.dataset.on) return; box.dataset.on = '1';
    var step = function () { var c = r.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(r).columnGap || 0) : r.clientWidth; };
    box.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () { r.scrollBy({ left: step() * (b.dataset.dir > 0 ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
    });
    var upd = function () { if (!pos) return; var n = r.children.length, st = step(), a = Math.min(n, Math.round(r.scrollLeft / st) + 1), b = Math.min(n, a + Math.max(1, Math.floor((r.clientWidth - parseFloat(getComputedStyle(r).paddingLeft || 0) - parseFloat(getComputedStyle(r).paddingRight || 0) + parseFloat(getComputedStyle(r).columnGap || 0) + 2) / st)) - 1); pos.textContent = (b > a ? a + '–' + b : String(a)) + ' of ' + n; };
    r.addEventListener('scroll', upd, { passive: true }); upd();
  }
  function scan(root) { (root || document).querySelectorAll('[data-ja-rail]').forEach(init); }
  /* Perf: rails are below the fold, so set them up when the browser is idle (no layout reads during load). */
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 300); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { idle(function () { scan(); }); }); else idle(function () { scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
/* Add to bag -> AJAX + open the cart drawer (falls back to /cart if the drawer is absent). */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f.matches || !f.matches('form.ja-buy, form.ja-sizes__panel')) return;
    if (!document.getElementById('cart-drawer') || !window.fetch) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (j) {
        var m = f.querySelector('[data-ja-live]') || document.querySelector('[data-ja-live]');
        if (m) m.textContent = (j && j.description) || 'Could not add to your bag. Please try again.';
      })
      .then(function () { if (b) b.classList.remove('is-adding'); });
  });
})();
